import { render } from "./supportTicketProduct.vue?vue&type=template&id=6ec18d90&ts=true"
import script from "./supportTicketProduct.vue?vue&type=script&lang=ts"
export * from "./supportTicketProduct.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__